const API_BASE_URL = 'https://winter.codes/api';

export async function fetchPostageAccounts() {
    const response = await fetch(`${API_BASE_URL}/postage-accounts`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    if (!response.ok) {
        throw new Error(`HTTP status ${response.status}`);
    }
    return await response.json();
}

export async function fetchPaginatedPostageAccounts(pageNumber = 1, pageSize = 20) {
    const url = `${API_BASE_URL}/postage-accounts/paginated?page=${pageNumber}&pageSize=${pageSize}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    if (!response.ok) {
        throw new Error(`HTTP status ${response.status}`);
    }
    return await response.json();
}

export async function fetchPostageAccountDetails(postageAccountNumber) {
    const id = postageAccountNumber - 999999999; //Convert PostageAccountNumber to Id
    console.log(`Fetching details for ID: ${id} from PostageAccountNumber: ${postageAccountNumber}`);
    const response = await fetch(`${API_BASE_URL}/postage-accounts/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to fetch account details.');
    }
    return await response.json();
}

export async function checkWorktagString(worktagString) {
    const response = await fetch(`${API_BASE_URL}/postage-accounts/check-worktag?worktagString=${worktagString}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error('Failed to check worktag string');
    }
    return await response.json();
  }
  

export async function updatePostageAccount(postageAccountNumber, accountDetails) {
    const id = postageAccountNumber - 999999999;
    const response = await fetch(`${API_BASE_URL}/postage-accounts/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(accountDetails)
    });
    if (!response.ok) {
        throw new Error(`HTTP status ${response.status}`);
    }
    return response.ok;
}


export async function changePostageAccountOwner(postageAccountNumber, newOwnerNetId) {
    const id = postageAccountNumber - 999999999;
    const response = await fetch(`${API_BASE_URL}/postage-accounts/${id}/change-owner`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ newOwnerNetId })
    });
    if (!response.ok) {
        throw new Error(`HTTP status ${response.status}`);
    }
    return response.ok;
}


export async function addAuthorizedUserToPostageAccount(postageAccountNumber, authUserNetId) {
    const id = postageAccountNumber - 999999999;
    const response = await fetch(`${API_BASE_URL}/postage-accounts/${id}/add-auth-user`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ authUserNetId: authUserNetId })
    });
    if (!response.ok) {
        throw new Error(`HTTP status ${response.status}`);
    }
    return response.ok;
}

export async function removeAuthorizedUserFromPostageAccount(postageAccountNumber, authUserNetId) {
    const id = postageAccountNumber - 999999999;
    const response = await fetch(`${API_BASE_URL}/postage-accounts/${id}/remove-auth-user`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ authUserNetId: authUserNetId })
    });
    if (!response.ok) {
        throw new Error(`HTTP status ${response.status}`);
    }
    return response.ok;
}


export async function fetchPostageAccountsByOwnerNetId(netId) {
    const response = await fetch(`${API_BASE_URL}/postage-accounts/search?ownerNetId=${netId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to fetch postage accounts');
    }
    return await response.json();
}


export async function fetchPostageAccountsByAuthorizedUserNetId(netId) {
    const response = await fetch(`${API_BASE_URL}/postage-accounts/search?authorizedUserNetId=${netId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to fetch postage accounts');
    }
    return await response.json();
}


export const createPostageAccount = async (accountData) => {
    const response = await fetch(`${API_BASE_URL}/postage-accounts`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(accountData)
    });

    if (!response.ok) {
        const message = `An error has occurred: ${response.status}`;
        throw new Error(message);
    }

    return response.json();
};

export async function reviewWorktagChangeRequest(postageAccountNumber, accountDetails) {
    const id = postageAccountNumber - 999999999;
    const response = await fetch(`${API_BASE_URL}/postage-accounts/${id}/review-worktag-change-request`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(accountDetails)
    });
    if (!response.ok) {
        throw new Error(`HTTP status ${response.status}`);
    }
    return response.ok;
}   

export async function searchPostageAccounts(searchParams) {
    const query = new URLSearchParams();

    // Iterate over each search parameter and only add it if it has a value
    Object.keys(searchParams).forEach(key => {
        if (searchParams[key]) { // This checks for non-empty or non-undefined values
            query.append(key, searchParams[key]);
        }
    });

    const url = `${API_BASE_URL}/postage-accounts/search?${query.toString()}`;
    const response = await fetch(url, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch search results');
    }
    return await response.json();
}



/************************************ 
* USER API CALLS
************************************/

export async function fetchAllUsers() {
    const response = await fetch(`${API_BASE_URL}/postage-users`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return await response.json();
};

export async function fetchPaginatedUsers(pageNumber = 1, pageSize = 20) {
    const response = await fetch(`${API_BASE_URL}/postage-users/paginated?page=${pageNumber}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return await response.json();
}


export async function fetchUserDetailsByNetId(netId) {
    const response = await fetch(`${API_BASE_URL}/postage-users/netid/${netId}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to fetch user details');
    }
    return await response.json();
};


export const updateUserDetails = async (netId, userDetails) => {
    console.log(JSON.stringify(userDetails));
    const response = await fetch(`${API_BASE_URL}/postage-users/edit/${netId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userDetails)
    });

    if (!response.ok) {
        const message = `An error has occurred: ${response.status}`;
        throw new Error(message);
    }
    return response.ok;
};


export const createPostageUser = async (accountData) => {
    const response = await fetch(`${API_BASE_URL}/postage-users`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(accountData)
    });

    if (!response.ok) {
        const message = `An error has occurred: ${response.status}`;
        throw new Error(message);
    }

    return response.json();
};

export async function searchPostageUsers(searchParams) {
    const query = new URLSearchParams();

    // Iterate over each search parameter and only add it if it has a value
    Object.keys(searchParams).forEach(key => {
        if (searchParams[key]) { // This checks for non-empty or non-undefined values
            query.append(key, searchParams[key]);
        }
    });

    const url = `${API_BASE_URL}/postage-users/search?${query.toString()}`;
    const response = await fetch(url, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch search results');
    }
    return await response.json();
}

/*
CREATING POST USERS - JSON BODY EXPECTATION
{
  "netID": "string",
  "firstName": "string",
  "lastName": "string",
  "department": "string",
  "boxNumber": "string",
  "phone": "string"
}
*/
